import React, { useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import cN from 'classnames';
import { useTranslation } from 'react-i18next';
import { Button } from '@lion-design/core';
import { RootState } from '@Redux/detail/store';
import * as Icons from '@components/Common/Icons';
import SlidePage from '@components/Common/SlidePage';
import GroupDetailPrice from '@components/DetailPage/GroupDetailPrice';
import GroupAllDetailMore from '@components/DetailPage/GroupAllDetailMore';
import GroupAllList from '@components/DetailPage/GroupAllList';
import GroupAllTours from '@components/DetailPage/GroupAllTours';
import { Info } from '@components/Common/Icons';
import { setTodayMore } from '@Redux/detail/Group/actions';
import ContactStaff from '@components/Common/ContactStaff';
import dayjs from 'dayjs';
import styles from '../style.module.scss';

function Register() {
    const { GroupInfo, IsB2E, isHeaderShow, callJson, TelType } = useSelector(
        (store: RootState) => store.groupReducer
    );
    const dispatch = useDispatch();
    const [isFeeOpen, setIsFeeOpen] = useState<boolean>(false);
    const [isMoreOpen, setIsMoreOpen] = useState<boolean>(false);
    const [isContactOpen, setIsContactOpen] = useState<boolean>(false);
    const [isCalendarOpen, setIsCalendarOpen] = useState<boolean>(false);
    const priceRef = useRef<any>(null);
    const { t } = useTranslation();

    const isMobile = useMediaQuery({ query: '(max-width: 980px)' });

    // 若為 "額滿"、"關團"、"取消"、"關團(因疫情）"，則 disable 按鈕
    const disabledBtn = [3, 5, 7, 99].includes(GroupInfo.Status);

    const currency = GroupInfo.CurrencyCode || '';

    const showOrigPrice = (!!GroupInfo.IsVip || !!IsB2E) && (
        <div className={styles.orgprice}>
            原價:<span>{GroupInfo.OrigPrice}人/起</span>
        </div>
    );

    const statusText = (status: number) => {
        switch (status) {
            case 1:
                return '立即報名';
            case 2:
                return '候補';
            case 3:
                return '額滿';
            case 4:
                return '請洽專員';
            case 5:
                return t('closeGroup');
            case 6:
                return '預定';
            case 7:
                return '取消';
            case 8:
                return '我有意願';
            // 因應疫情
            case 99:
                return t('closeGroup');
            default:
                return '';
        }
    };
    const todayMoreReqBody = {
        NormGroupID: GroupInfo.NormGroupID,
        GoDate: dayjs(GroupInfo.GoDate).format('YYYY-MM-DD'),
    };

    function clickTodayMore() {
        dispatch(setTodayMore(todayMoreReqBody));
        setIsMoreOpen(true);
    }

    return (
        <div className={styles['register-wrapper']}>
            {GroupInfo.MutiGroup && (
                <div className={styles['more-tour']} onClick={() => clickTodayMore()}>
                    {t('todayMoreGroups')}
                </div>
            )}
            <div className={styles['price-wrapper']}>
                <div className={styles['price-info']}>
                    <div className={styles['price-box']}>
                        {disabledBtn ? (
                            <div className={styles.tips}>
                                <Icons.Time />
                                親愛的！你慢了一步！
                            </div>
                        ) : (
                            <>
                                {showOrigPrice}
                                <div className={styles.price}>
                                    <span>
                                        {GroupInfo.Status == 6
                                            ? '近期上架'
                                            : `${currency} ${GroupInfo.Price}`}
                                    </span>
                                    人/起
                                </div>
                            </>
                        )}
                    </div>
                </div>
                <div className={styles.btns} ref={priceRef}>
                    <Button
                        className={styles['btn-primary-border']}
                        onClick={() => setIsCalendarOpen(true)}
                    >
                        選擇出發日期
                    </Button>
                    {!disabledBtn && (
                        <Button
                            className={cN(styles['show-pc'])}
                            onClick={() => setIsFeeOpen(true)}
                        >
                            費用說明
                        </Button>
                    )}
                    <Button
                        className={styles['btn-primary']}
                        {...(disabledBtn ? { disabled: true } : { href: GroupInfo.StatusUrl })}
                        onClick={() => {
                            GroupInfo.Status == 4 && setIsContactOpen(true);
                        }}
                    >
                        {statusText(GroupInfo.Status)}
                    </Button>
                </div>
                <SlidePage
                    visible={isCalendarOpen}
                    setIsVisible={setIsCalendarOpen}
                    title="選擇出發日期"
                >
                    <>
                        <GroupAllTours />
                        <GroupAllList slidePageVisible={setIsCalendarOpen} />
                    </>
                </SlidePage>
            </div>
            {isMobile && isHeaderShow && (
                <div className={styles.stickyFooter}>
                    {!disabledBtn && (
                        <div className={styles.price}>
                            <span className={styles['price_rate']}>
                                {GroupInfo.Status == 6
                                    ? '近期上架'
                                    : `${currency} ${GroupInfo.Price}`}
                            </span>
                            人/起
                        </div>
                    )}
                    {!disabledBtn && (
                        <div className={styles['price_info']} onClick={() => setIsFeeOpen(true)}>
                            費用說明
                        </div>
                    )}
                    <Button
                        className={styles['btn-primary']}
                        {...(disabledBtn ? { disabled: true } : { href: GroupInfo.StatusUrl })}
                        onClick={() => {
                            GroupInfo.Status == 4 && setIsContactOpen(true);
                        }}
                    >
                        {statusText(GroupInfo.Status)}
                    </Button>
                </div>
            )}
            {/* 光箱 */}
            <GroupDetailPrice open={isFeeOpen} ToggleLightBox={() => setIsFeeOpen(false)} />
            <GroupAllDetailMore open={isMoreOpen} ToggleLightBox={() => setIsMoreOpen(false)} />
            <ContactStaff
                open={isContactOpen}
                ToggleLightBox={() => {
                    setIsContactOpen(false);
                }}
                callJson={callJson}
                origin="detail"
                GroupInfo={GroupInfo}
            />
        </div>
    );
}

export default Register;
